export default "__VITE_ASSET__Ccf63MIv__"